import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectInnerSidebarVisible } from '../../features/ui/uiSlice';
import styles from './InnerSidebar.module.scss';

export const InnerSidebar = () => {
    const isVisible = useSelector(selectInnerSidebarVisible);
    const history = useHistory();

    const handleProductClick = (productName) => {
        if (productName === 'Virtual Gallery') {
            history.push('/policy');
        } else {
            console.log(`Selected product: ${productName}`);
        }
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className={styles['inner-sidebar']}>
            <div className={styles['sidebar-header']}>
                Products
            </div>
            <ul className={styles['product-list']}>
                <li
                    className={styles['product-item']}
                    onClick={() => handleProductClick('Virtual Gallery')}
                >
                    Virtual Gallery
                </li>
                <li
                    className={styles['product-item']}
                    onClick={() => handleProductClick('Wellbeing Care')}
                >
                    Wellbeing Care
                </li>
            </ul>
        </div>
    );
};
